import React, { useState, useEffect } from "react"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { UncontrolledCarousel } from "reactstrap"
import a from "../../assets/images/icon/a1.png"
import b from "../../assets/images/icon/a2.png"
import c from "../../assets/images/icon/a3.png"
import d from "../../assets/images/icon/a4.png"
import e from "../../assets/images/icon/a5.png"
import f from "../../assets/images/icon/a6.png"
import g from "../../assets/images/icon/a15.png"
import h from "../../assets/images/icon/a12.png"
import j from "../../assets/images/icon/a14.png"
import l from "../../assets/images/icon/a10.png"
import m from "../../assets/images/icon/a13.png"
import n from "../../assets/images/icon/top-customers.png"
import { URLS } from "../../Url"
import axios from "axios"

const Dashboard = () => {
  const history = useHistory()
  const [dashboardData, setDashboardData] = useState({})
  const [stores, setStores] = useState([])
  const [deals, setDeals] = useState([])
  const [mediaItems, setMediaItems] = useState([])

  // Get token from localStorage
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = GetAuth ? JSON.parse(GetAuth) : null
  const TokenData = TokenJson?.token || ""

  // Order summary cards
  const summaryCards = [
    { title: "New", value: dashboardData.newOrders || 0, icon: a, str: "new" },
    {
      title: "Pending",
      value: dashboardData.pendingOrders || 0,
      icon: b,
      str: "pending",
    },
    {
      title: "Shipped",
      value: dashboardData.shippedOrders || 0,
      icon: c,
      str: "shipped",
    },
    { title: "Dues", value: dashboardData.dues || 0, icon: d, str: "due" },
    { title: "Paid", value: dashboardData.paid || 0, icon: e, str: "paid" },
    {
      title: "Completed",
      value: dashboardData.completedOrders || 0,
      icon: f,
      str: "closed",
    },
    {
      title: "Rejected",
      value: dashboardData.rejectedOrders || 0,
      icon: g,
      str: "rejected",
    },
    {
      title: "Cancelled",
      value: dashboardData.cancelledOrders || 0,
      icon: h,
      str: "cancelled",
    },
  ]

  // Analytics cards
  const analyticsCards = [
    { title: "Sales trend", icon: m, str: "/Analytics1" },
    { title: "Product sale", icon: j, str: "/Analytics2" },
    { title: "Sales category", icon: l, str: "/Analytics3" },
    { title: "Top Customers", icon: n, str: "/Analytics3" },
  ]

  // Fetch dashboard data
  const getDashboardData = async () => {
    try {
      const response = await axios.post(
        URLS.GetDashboard,
        {},
        {
          headers: { Authorization: `Bearer ${TokenData}` },
        }
      )

      const data = response?.data || {}
      setDashboardData(data)
      setStores(data?.stores || [])
      setDeals(data?.deals || [])

      // Process media items
      const processedMedia = (data?.advertisements || []).map((item, index) => {
        const mediaUrl = `${URLS.Base}${item.image || item.video}`
        const isVideo = !!item.video
        return {
          src: mediaUrl,
          altText: `Media ${index + 1}`,
          caption: "",
          key: index,
          isVideo,
          type: isVideo ? "video" : "image",
        }
      })
      setMediaItems(processedMedia)
    } catch (error) {
      console.error("Error fetching dashboard data:", error)
    }
  }

  // Handlers
  const handleViewDeal = deal => {
    sessionStorage.setItem("Dealid", deal._id)
    history.push("/ViewDeal")
  }

  const handleViewOrders = card => {
    sessionStorage.setItem("str", card.str)
    history.push("/AllOrders")
  }

  const handleViewAnalytics = card => {
    history.push(card.str)
  }

  // Effects
  useEffect(() => {
    getDashboardData()
  }, [])

  // Section header component
  const SectionHeader = ({ title, linkTo, linkText = "See All" }) => (
    <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
      <h6 className="mb-0 fw-semibold" style={{ fontSize: "18px" }}>
        {title}
      </h6>
      {linkTo && (
        <Link to={linkTo} className="btn btn-sm btn-outline-primary">
          {linkText} <i className="fas fa-arrow-right ms-1"></i>
        </Link>
      )}
    </div>
  )

  // Empty state component
  const EmptyState = ({ iconClass = "bx-image-alt", message }) => (
    <div className="text-center p-5 border rounded">
      <div className="mb-3">
        <i className={`bx ${iconClass} display-4 text-muted`}></i>
      </div>
      <p className="text-muted mb-0">{message}</p>
    </div>
  )

  return (
    <div className="page-content">
      <Container fluid className="p-0">
        {/* Order Summaries Section */}
        <div className="mb-4">
          <SectionHeader title="Order Summaries" />
          <Row className="g-3">
            {summaryCards.map((card, index) => (
              <Col key={index} xs={6} sm={4} md={3} lg={3} xl={2} xxl={2}>
                <Card
                  className="shadow-sm border-0 h-100 hover-shadow"
                  style={{
                    cursor: "pointer",
                    borderRadius: "8px",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => handleViewOrders(card)}
                >
                  <CardBody className="p-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="text-start">
                        <h4
                          className="mb-1 fw-bold text-dark"
                          style={{
                            fontSize: "22px",
                            cursor: "pointer",
                          }}
                        >
                          {card.value}
                        </h4>
                        <p className="mb-0 text-muted">{card.title}</p>
                      </div>
                      <div className="flex-shrink-0">
                        <img
                          src={card.icon}
                          alt={card.title}
                          style={{
                            width: "45px",
                            height: "45px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Analytics Section */}
        <div className="mb-4">
          <SectionHeader title="View Sales Analytics" />
          <Row className="g-3">
            {analyticsCards.map((card, index) => (
              <Col key={index} xs={6} sm={4} md={3} lg={3} xl={2} xxl={2}>
                <Card
                  className="shadow-sm border-0 h-100 hover-shadow text-center"
                  style={{
                    cursor: "pointer",
                    borderRadius: "8px",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => handleViewAnalytics(card)}
                >
                  <CardBody className="p-3">
                    <div className="mb-2">
                      <img
                        src={card.icon}
                        alt={card.title}
                        style={{
                          width: "55px",
                          height: "55px",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <p className="mb-0 text-muted">{card.title}</p>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* My Store Section */}
        <div className="mb-4">
          <SectionHeader title="My Store" />
          {stores.length > 0 ? (
            stores.map((store, index) => (
              <div key={index} className="mb-3">
                <Link to="/ViewSeller">
                  <img
                    src={URLS.Base + store.storeBanner}
                    alt={store.name}
                    className="img-fluid rounded shadow-sm w-100"
                    style={{
                      height: "280px",
                      objectFit: "cover",
                    }}
                  />
                </Link>
              </div>
            ))
          ) : (
            <EmptyState message="No Store available" />
          )}
        </div>

        {/* Deals Section */}
        <div className="mb-4">
          <SectionHeader title="Deals" linkTo="/Deals" />
          {deals.length > 0 ? (
            <Row className="g-3">
              {deals.map((deal, index) => (
                <Col key={index} xs={6} sm={4} md={3} lg={3} xl={3} xxl={3}>
                  <Card
                    className="shadow-sm border-0 h-100 hover-shadow"
                    style={{
                      cursor: "pointer",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}
                    onClick={() => handleViewDeal(deal)}
                  >
                    <div
                      className="position-relative"
                      style={{
                        height: "150px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={URLS.Base + deal.image}
                        alt={deal.name}
                        className="img-fluid w-100 h-100"
                        style={{
                          objectFit: "cover",
                          transition: "transform 0.3s ease",
                        }}
                        onMouseEnter={e =>
                          (e.currentTarget.style.transform = "scale(1.05)")
                        }
                        onMouseLeave={e =>
                          (e.currentTarget.style.transform = "scale(1)")
                        }
                      />
                    </div>
                    <CardBody className="p-3 text-center">
                      <h6 className="mb-0 fw-semibold text-truncate">
                        {deal.name}
                      </h6>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <EmptyState message="No Deals available" />
          )}
        </div>

        {/* Advertisements Section */}
        <div className="mb-4">
          <SectionHeader title="Advertisements" linkTo="/Advertisements" />
          {mediaItems.length > 0 ? (
            <div className="border rounded overflow-hidden shadow-sm">
              <UncontrolledCarousel
                items={mediaItems}
                indicators={mediaItems.length > 1}
                controls={mediaItems.length > 1}
                autoPlay={true}
                interval={3000}
                className="ad-carousel"
              />
            </div>
          ) : (
            <EmptyState message="No advertisements available" />
          )}
        </div>
      </Container>
    </div>
  )
}

export default Dashboard
